import React from 'react';
import { ProgressBar } from 'react-bootstrap';

export default (props) => {
  return (
    <ProgressBar className={'bgvProgressBar'} max={props.max} min={props.min} now={props.now} />
  );
};
